import webApi from "../WebApi/WebApi";

import webApi2 from "../WebApi/WebApi2";


export const getDistrictList = async () => {
    return await webApi2.post(`/api/GetDistrict`,);
}
export const getBlockList = async (data) => {
    return await webApi2.post(`/api/GetBlock/${data ? data : 0}`,);
}
export const getGpList = async (data) => {
    return await webApi2.post(`/api/GetGP/${data ? data : 0}`,);
}

export const getTotalAvailableFund = async (dist, block, gp, report) => {
    return await webApi.get(`/MIS/TotalAvailableFund?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&rptType=${report}`,);
}

export const getTotalTaxNonTaxAmount = async (dist, block, gp, report) => {
    return await webApi.get(`/MIS/TaxNonTaxAmount?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&rptType=${report}`,);
}


